import { PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
export const DEFAULT_PURCHASE_CYCLE = {
  cycleType: PurchaseOffering.CycleType.RECURRING,
  cycleDuration: {
    unit: PurchaseOffering.DurationUnit.YEAR,
    count: 1
  }
};
export const DEFAULT_SALE_PURCHASE_CYCLE = {
  cycleType: PurchaseOffering.CycleType.RECURRING,
  cycleDuration: {
    unit: PurchaseOffering.DurationUnit.YEAR,
    count: 2
  }
};

// Eclipse color palette - references CSS custom properties defined in styles/colors.scss
// This ensures a single source of truth for colors across TypeScript and SCSS
export const ECLIPSE_BG = 'var(--eclipse-bg-color)';
export const ECLIPSE_PRIMARY_COLOR = 'var(--eclipse-text-color)';
export const ECLIPSE_BLACK_TEXT_COLOR = 'var(--eclipse-black-text-color)';
export const ECLIPSE_SALE_BG_COLOR = 'var(--eclipse-sale-bg-color)';
export const ECLIPSE_SALE_TEXT_COLOR = 'var(--eclipse-sale-text-color)';
export const ECLIPSE_BORDER_COLOR = 'var(--eclipse-border-color)';
export const ECLIPSE_CYCLE_DEFAULT_STROKE = 'var(--eclipse-cycle-default-stroke)';
export const ECLIPSE_SECONDARY_TEXT_COLOR = 'var(--eclipse-secondary-text-color)';
export const ECLIPSE_DISABLED_BORDER_COLOR = 'var(--eclipse-disabled-border-color)';
export const FREE_DOMAIN_PLAN_CARD_TRANSLATION_KEY = 'premium-purchase-plan.cards.feature.free_domain';
export const FREE_DOMAIN_PLAN_CARD_UP_TO_3_YEARS_TRANSLATION_KEY = 'premium-purchase-plan.cards.feature.free_domain_up_to_3_years';
export const FREE_DOMAIN_CHECKOUT_SUMMARY_ONE_YEAR_KEY = 'premium-purchase-plan.checkout_summary.free_domain_for_1_year';
//# sourceMappingURL=consts.js.map